<template>
  <div class="mx-3">
  
    <Toast />
    <div class="card" style="position: relative !important;">
      <Toolbar class="mb-4">
        <template #start>
          <Button label="New" icon="pi pi-plus" class="p-button-success mr-2" @click="openNew" />
        </template>

        <template #end>
          <Button label="Export" icon="pi pi-upload" class="p-button-help" @click="exportCSV($event)" />
        </template>
        

      </Toolbar>

        <p class="mx-3">Filter Expire At</p>
        <div class="m-4">

          <label for="">Select Date</label>
          <month-picker-input :defaultYear="currentYear"  :defaultMonth="currentMonth" @change="viewPagesFilter"></month-picker-input>
        </div>

      <DataTable ref="dt" :value="this.userPages" dataKey="id" :paginator="true" :rows="10" :filters="filters"
        class="p-datatable-lg " style="position:unset !important"
        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
        :rowsPerPageOptions="[5, 10, 25]" currentPageReportTemplate="Showing {first} to {last} of {totalRecords} users"
        responsiveLayout="scroll">


        <Column field="id" header="Id"></Column>
        <Column field="name" header="Name"></Column>
        <Column field="dashboard_role.role_name" header="Role"></Column>
        <Column field="subscription.name" header="Subscription"></Column>
        <Column field="sub_expire_date" header="Expire At"></Column>
        <Column field="contacts_count" header="Contacts"></Column>
        <Column field="users_count" header="Users"></Column>
        <Column field="sub_expired" header="Expired"></Column>
        <Column field="limit_contacts" header="Contact Limit"></Column>
        <Column field="admin.name" header="Admin Name"></Column>
        <Column field="admin.phone" header="Admin phone"></Column>
        <!-- <Column :exportable="false" style="min-width: 10rem">
          <template #body="data">
            <Button v-if="data.data.whatsapp != null" label="Edit Whatsapp" class="p-button-outlined"
              @click="EditWhatsapp(data.data.whatsapp, data.data.subscription_id)" />
          </template>
        </Column>

        <Column :exportable="false" style="min-width: 10rem">
          <template #body="data">
            <Button label="Edit Subscribtion" class="p-button-outlined" @click="openSubscribeDialog(data.data)" />

          </template>
        </Column> -->

        <!-- <Column :exportable="false" style="min-width: 10rem">
          <template #body="data">
            <Button label="View Users" class="p-button-outlined" @click="viewUsers(data.data.id)" />
          </template>
        </Column> -->

      </DataTable>
    </div>

  </div>
</template>

<script>
import pageSrevice from "./service/FilterService";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import Button from "primevue/button";
import Toast from 'primevue/toast';
import subscriptionService from "./service/SubscriptionService";

import { MonthPickerInput } from 'vue-month-picker'




export default {
  components: {
    DataTable: DataTable,
    Column: Column,
    Button: Button,
    MonthPickerInput,

    Toast,
  },
  data() {
    return {
      date: {
      from: null,
      to: null,
      month: null,
      year: null
      },
      users: null,
      statuses: [],
      StatusesWithCountUsers: [],
      subscriptions: null,
      UserAddDialog: false,
      deleteUser: false,
      WhatsappAccountAddDialog: false,
      pageEditSubscribtionDialog: false,
      user: {},
      whatsapp_account: {},
      subscriptions_data:{},
      currentDate: new Date(),

      user_NewStatus: {},
      userStatusAddDialog: false,
      userStatus_edit: false,
      submitted: false,
      UserEdiDialog: false,
      submittedEdit: false,
      whatsapp_account_edit: false,
      userPages: null,
      // userPagesDialog: false,
      userStatusDialog: false,
      userStatuses: null,
      pageUsers: null,
      user_id: null,
      user_is_open: null,
      PageUsersDialog: false,
      // username : null 
    };
  },
  pageSrevice: null,
  created() {

    console.log(this.currentMonth,
this.currentYear);
    this.subscriptionService = new subscriptionService();
    this.pageSrevice = new pageSrevice();
  },
  mounted() {
    this.pageSrevice.getPages().then((data) => {
      this.userPages = data.data;
      console.log(this.userPages.data[0].admins[0].id);
    });
    // this.viewPages();
  },
  computed: {
    currentMonth() {
      return this.currentDate.getMonth() + 1;
    },
    currentYear() {
      return this.currentDate.getFullYear();
    }
  },
  methods: {

    openSubscribeDialog(page) {
      this.subscriptions_data = {};
      this.subscriptions_data.page_id = page.id;
      this.subscriptions_data.subscription_id = page.subscription_id;
      this.pageEditSubscribtionDialog = true;
    },

    
   
    openNew() {
      this.user = {};
      this.UserAddDialog = true;
    },

    // hideDialog(type = null) {
    //   this.UserAddDialog = false;
    //   this.whatsapp_account_edit = false;
    //   this.userStatus_edit = false;
    //   this.WhatsappAccountAddDialog = false;
    //   this.userStatusAddDialog = false;
    //   this.whatsapp_account = {};
    //   this.user = {};
    //   this.subscriptions_data={};
    //   this.submitted = false;
    //   this.UserEdiDialog = false;
    //   this.submittedEdit = false;
    //   this.pageEditSubscribtionDialog = false;



    // },


   
    

    viewPages() {
      // this.username = user.name ;
      // console.log(this.username)
      this.pageSrevice.getPages().then((data) => {
        this.userPages = data.data.data
        // this.user_is_open = user;
        // this.userPagesDialog = true;

      })
    },

    
    viewPagesFilter(date) {
      console.log('viewPagesFilter',date);
      this.pageSrevice.getPages(date.monthIndex,date.year).then((data) => {
        this.userPages = data.data.data
      })
    },


    viewUsers(pageId) {
      // console.log(pageId)
      this.pageSrevice.pageUsers(pageId).then((data) => {
        this.pageUsers = data.data.data.all_users;
        this.PageUsersDialog = true;
      })
    },

    exportCSV() {
      this.$refs.dt.exportCSV();
    },

  },
};
</script>

<style lang="scss" scoped>
.table-header {
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media screen and (max-width: 960px) {
    align-items: start;
  }
}

.p-dialog .product-image {
  width: 50px;
  margin: 0 auto 2rem auto;
  display: block;
}

.confirmation-content {
  display: flex;
  align-items: center;
  justify-content: center;
}

.status_item .card{
  box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.1);
  cursor: pointer;
}

.status_item:hover .card {
  background-color: #ddd;
}

.status_item.active .card {
  background-color: #27ae60;
  color: #ecf0f1;
}



@media screen and (max-width: 960px) {
  ::v-deep(.p-toolbar) {
    flex-wrap: wrap;

    .p-button {
      margin-bottom: 0.25rem;
    }
  }
}
</style>
<style scoped>

.month-picker__container {
    position: relative !important;
    top: 0em !important;
}
</style>
